import { notifications } from '@mantine/notifications'
import { trpc } from '../trpc'

export const userHooks = {
  useMe: () => trpc.user.me.useQuery(),
  useUpdateName: () => {
    const utils = trpc.useUtils()
    return trpc.user.update.useMutation({
      onSuccess: () => {
        utils.user.me.invalidate()
        notifications.show({
          title: 'Tiedot päivitetty',
          message: 'Nimesi on päivitetty onnistuneesti',
          color: 'green',
        })
      },
      onError: (error) => {
        notifications.show({
          title: 'Virhe',
          message: error.message || 'Tietojen päivitys epäonnistui',
          color: 'red',
        })
      },
    })
  },
  useUpdateMarketingConsent: () => {
    const utils = trpc.useUtils()
    return trpc.user.updateMarketingConsent.useMutation({
      onSuccess: () => {
        utils.user.me.invalidate()
      },
      onError: (error) => {
        notifications.show({
          title: 'Virhe',
          message: error.message || 'Asetusten päivitys epäonnistui',
          color: 'red',
        })
      },
    })
  },
}
